import * as amplitude from '@amplitude/analytics-browser';

import { isDev } from '~/dev/utils/isDev';

export const identifyAmplitudeUser = (user: { id: number; client: number }) => {
  if (isDev || !user) return;

  amplitude.setUserId(`${user.id}_${user.client}`);
};
